import nodeStyles from '../constants/nodeStyles';
import nodeStates from '../constants/nodeStates';
import findLast from 'lodash/findLast';
import groupBy from 'lodash/groupBy';
import reduce from 'lodash/reduce';
import {
    sortOrderOfNodeAtFault,
    sortOrderOfLastCompletedBag,
    isTimeLineHealthy,
} from './nodeTimelineHelper';

function createStyleForCompletedFlightNode(node, timelineNodes) {
    if (isTimeLineHealthy(timelineNodes)) {
        return nodeStyles.success;
    }

    if (
        node.sortOrder > sortOrderOfNodeAtFault(timelineNodes) &&
        node.sortOrder > sortOrderOfLastCompletedBag(timelineNodes)
    ) {
        return nodeStyles.void;
    }
    return nodeStyles.success;
}

function createStyleForMissedNode(node, timelineNodes) {
    if (node.sortOrder < sortOrderOfLastCompletedBag(timelineNodes)) {
        return nodeStyles.pickedUp;
    }

    if (node.sortOrder > sortOrderOfNodeAtFault(timelineNodes)) {
        return nodeStyles.void;
    }
    return node.sortOrder === sortOrderOfNodeAtFault(timelineNodes) &&
        node.sortOrder > sortOrderOfLastCompletedBag(timelineNodes)
        ? nodeStyles.critical
        : nodeStyles.pickedUp;
}

export function getNodeStyle(node, timelineNodes) {
    switch (node.state) {
        case nodeStates.missed:
            return createStyleForMissedNode(node, timelineNodes);
        case nodeStates.completedBag:
            return nodeStyles.success;
        case nodeStates.future:
            return nodeStyles.future;
        case nodeStates.completedFlight:
            return createStyleForCompletedFlightNode(node, timelineNodes);
        case nodeStates.completedReflight:
            return nodeStyles.reflight;
        default:
            return nodeStyles.success;
    }
}

function createTimelineWithPartitionEnd(timelineNodes) {
    var currentPartitionEnd = findLast(timelineNodes).sortOrder;

    for (let i = timelineNodes.length - 1; i >= 0; i--) {
        var node = timelineNodes[i];

        node.partitionEnd = currentPartitionEnd;

        if (node.state === nodeStates.completedReflight) {
            currentPartitionEnd = node.sortOrder;
        }
    }

    return timelineNodes;
}

function timelinePartitionBuilder(timelineNodes) {
    const nodes = timelineNodes.map((node) => ({
        sortOrder: node.sortOrder,
        style: getNodeStyle(node, timelineNodes),
    }));

    return nodes;
}

export default function timelineBuilder(timelineNodes) {
    const timelineWithPartitionEnd =
        createTimelineWithPartitionEnd(timelineNodes);

    const nodesGroupedByPartitionEnd = groupBy(
        timelineWithPartitionEnd,
        'partitionEnd'
    );

    const updatedTimelineNodes = reduce(
        nodesGroupedByPartitionEnd,
        (result, groupedNodes) => {
            var timelinePartitionNodes = timelinePartitionBuilder(groupedNodes);
            return [...result, ...timelinePartitionNodes];
        },
        []
    );

    return updatedTimelineNodes;
}
